import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LogService } from '../services/log.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private router: Router,
    private logService: LogService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.auth.isLoggedIn()) {
      this.logService.register('PAGE_ACCESS', 'Usuário acessou uma página protegida').subscribe({
        error: (err) => console.error('Erro ao registrar log de acesso', err)
      });
      if (state?.url?.startsWith('/home')) {
        this.router.navigate(['/feed'], { replaceUrl: true });
        return false;
      }
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
